const ZYC_ROOT = import.meta.env.VITE_SWOOLE_ROOT
const API_ROOT = import.meta.env.VITE_API_ROOT

const endpoints = {
  // 首页车辆列表
  homeCarList: `${ZYC_ROOT}/v1/cars`,
  // 首页文章列表
  articles: `${ZYC_ROOT}/v1/articles`,
  // 车辆详情
  carDetail: `${ZYC_ROOT}/v1/car`,
  // 里程曲线
  mileageReport:`${ZYC_ROOT}/v1/car/mileageReport`,
  // 车辆详情 - "猜你喜欢"-推荐车辆
  carDetailRecommendList: `${ZYC_ROOT}/v1/likes`,
  // 文章详情
  article: `${ZYC_ROOT}/v1/article`,
  // 筛选–品牌
  brands: `${ZYC_ROOT}/v1/filter-param-brand`,
  // 筛选-分站
  substations: `${ZYC_ROOT}/v1/filter-param-substations`,
  // 筛选–省份
  provinces: `${ZYC_ROOT}/v1/filter-param-province`,
  // Wechat JSSDK config
  WechatJSSdkConf: `${ZYC_ROOT}/v1/getJsSDK`,

  // 车型以及地区选择
  vehicles: `${API_ROOT}/get_option?category=carmodel`,
  regions: `${API_ROOT}/get_option?category=region`,

  // 里程、登记年月、服务站点
  registrationYears: `${ZYC_ROOT}/v1/sell_car/registration_year`,

  mileages: `${ZYC_ROOT}/v1/sell_car/mileage`,

  servicePlaces: `${ZYC_ROOT}/v1/sell_car/service_substations`,

  // 卖车
  recycle: `${ZYC_ROOT}/v1/sell_car`,

  // 车辆物流发运须知
  deliveryNotice: `${ZYC_ROOT}/v1/getProcedureDeliveryCar`,

  // 二鉴
  examineNotice: `${ZYC_ROOT}/gcar/appraise`,

  // 淘车回顾里程曲线接口
  mileageReportGcar:`${ZYC_ROOT}/gcar/v1/mileageReport`,

  // 低价区首页车辆列表
  wholesaleCars:`${ZYC_ROOT}/v1/cars`,
  // 低价区拍照归属地
  wholesaleProvince:`${ZYC_ROOT}/v1/filter-param-province`,
  // 低价区品牌
  wholesaleBrand:`${ZYC_ROOT}/v1/filter-param-brand`,
  // 低价区分站
  wholesalesubStations:`${ZYC_ROOT}/v1/filter-param-substations`,
  // repair
  repair:`${ZYC_ROOT}/v1/customer_service`,
  // standard report accessory 附件清单
  standardReportAccessory: `${ZYC_ROOT}/v1/car/attachmentList`,
  // appraiseReport 二鉴
  appraiseReport: `${ZYC_ROOT}/v1/car/appraiseReport`,
  // standardReportPreSalePreparation
  // https://ichenuonuo.yuque.com/bhhgr4/bldeyk/onl85s#bqYNC
  standardReportPreSalePreparation: `${ZYC_ROOT}/v1/car/repairList`,
  // standardReportComsumable
  // https://ichenuonuo.yuque.com/bhhgr4/bldeyk/onl85s#RmcpZ
  standardReportComsumable: `${ZYC_ROOT}/v1/car/consumablesList`,
  // standardInternalVideo
  standardInternalVideo: `${ZYC_ROOT}/v1/VehicleDisplayVideo/detail`,
  // standardConfiguration
  standardConfiguration: `${ZYC_ROOT}/v1/car/configurationChecklist`,
  // srandardBenchmark
  standardBenchmark: `${ZYC_ROOT}/v1/car/benchmark`,
}

export default endpoints
